import {Component, h, Prop} from "@stencil/core";

@Component({
  tag: "ike-loader",
  styleUrl: "ike-loader.scss",
  shadow: true,
})
export class IkeLoader { // loader with 3 bounced points
  @Prop() loading = false;

  // need to pass color to set points background-color.
  // - default : shop main color
  // - grey-dark : according to the shop theme (Light or Dark)
  @Prop() public color : string = "default";

  render() {
    return (
      <div class={this.loading ? "loader__init js-loader-init animated-loading" : "loader__init js-loader-init"}>
        <div class={'loader__anim ' + this.color}></div>
        <div class={'loader__anim ' + this.color}></div>
        <div class={'loader__anim ' + this.color}></div>
      </div>
    );
  }
}
